import React, { Component } from "react";
import { RoutedViewProps } from "@my-dld/utils/UrlUtils";
import { Redirect, Route, Switch } from "react-router";
import NewContract from "./New";
import RenewContract from "./Renew";
import TerminateContract from "./Terminate";
import TerminateSuccess from "./Terminate/success";
import EjariContextWrapper from "@eres/ejari-core/contexts/EjariContext";
import EjariContractContextWrapper, { IEjariContractContext } from "@eres/ejari-core/contexts/EjariContractContext";
import { Contract } from "@eres/ejari-api/Entity/contract";
import { TenancyContactAction } from "@eres/ejari-core/constants";
import NewContractSuccess from "./New/success";
import NewContractComplete from "./New/completed";


class EjariContract extends Component<RoutedViewProps> {
	render() {
		const pp = this.props.match.url;
		return <EjariContextWrapper>
			<EjariContractContextWrapper onContractActionFinished={ this.onContractActionFinished }>
				<Switch>
					<Route path={ [ pp + "/new/success", pp + "/renew/success" ] } component={ NewContractSuccess }/>
					<Route
						path={ [ pp + "/new/completed", pp + "/renew/completed" ] }
						component={ NewContractComplete }/>
					<Route path={ [ pp + "/new" ] } component={ NewContract }/>
					<Route path={ [ pp + "/renew" ] } component={ RenewContract }/>
					<Route path={ [ pp + "/terminate/success" ] } component={ TerminateSuccess }/>
					<Route path={ [ pp + "/terminate" ] } component={ TerminateContract }/>
					<Route path={ pp + "" } exact={ true }>
						<Redirect to={ pp + "/new" }/>
					</Route>
				</Switch>
			</EjariContractContextWrapper>
		</EjariContextWrapper>;
	}

	onContractActionFinished = ( ctx: IEjariContractContext, data: Contract | { Identity: number } ) => {
		switch ( ctx.action ) {
			case TenancyContactAction.TERMINATE_CONTRACT:
				this.props.history.replace( "terminate/success" );
				break;
			case TenancyContactAction.NEW_CONTRACT:
				this.props.history.replace( "new/success" );
		}
		// this.props.history.replace("/new/success")
	};
}

export default EjariContract;
